import React from 'react'
import { Formik } from 'formik'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useCreateContract, useReferentiel, useSuppliers } from 'api'
import { ContractForm } from './ContractForm'
import { schema } from './contractSchema'
import { addNotification } from 'notification'

export const ContractCreate: React.FC<{ done: () => void }> = ({ done }) => {
  const { t } = useTranslation()
  const [mutate, { data, status }] = useCreateContract()
  const referentiel = useReferentiel()
  const supplierOptions = useSuppliers()
  const history = useHistory()
  const [created, setCreated] = React.useState(false)

  React.useEffect(() => {
    if (!data || created) return
    setCreated(true)
    history.push(`/contrat/${data.Id}/informations`)
    setTimeout(done)
    addNotification({
      type: 'success',
      message: t('contract.infos.createSuccess', { name: data.Nom }),
    })
  }, [created, data, done, history, t])

  const values: Partial<Contract> = {
    Nom: '',
    Complement: '',
    Type: referentiel.ListeTypeContrat[0].value,
    Nrj: referentiel.ListeEnergie[0].value,
    DebutLivraison: moment().add(1, 'year').startOf('year').format(),
    FinLivraison: moment().add(1, 'year').endOf('year').format(),
    PaysId: referentiel.ListePays[0].value,
    Devise: referentiel.ListeDevise[0].value,
    FournisseurId: supplierOptions[0].value,
    DateSignature: moment().format(),
    DelaiReglement: null,
    ValorisationPas: referentiel.ListCHRPas[0].value
  }

  const submit = React.useCallback(
    async (values, actions) => {
      await mutate({ contract: values })
      actions.setSubmitting(false)
    },
    [mutate],
  )

  return (
    <Formik
      enableReinitialize
      initialValues={values}
      validationSchema={schema(t)}
      onSubmit={submit}
    >
      {(props) => <ContractForm isLoading={status === 'loading'} {...props} />}
    </Formik>
  )
}
